import React from 'react';
import Icon from '../../../components/AppIcon';

const ValidationChecks = ({ metrics }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Shield" size={24} color="var(--color-primary)" />
        <h2 className="text-xl font-semibold text-foreground">Validation Status</h2>
      </div>
      <div className="space-y-4">
        <div className="p-4 bg-background rounded-lg">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">Data Completeness</span>
            <span className="text-lg font-bold text-foreground">{metrics?.dataCompleteness}%</span>
          </div>
          <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
            <div
              className="h-full bg-success transition-all"
              style={{ width: `${metrics?.dataCompleteness}%` }}
            />
          </div>
        </div>

        <div className="p-4 bg-background rounded-lg">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">Regulatory Compliance</span>
            <span className="text-lg font-bold text-foreground">{metrics?.regulatoryCompliance}%</span>
          </div>
          <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
            <div
              className="h-full bg-success transition-all"
              style={{ width: `${metrics?.regulatoryCompliance}%` }}
            />
          </div>
        </div>

        <div className="p-4 bg-background rounded-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-foreground mb-1">Validation Issues</p>
              <p className="text-xs text-muted-foreground">Last updated: {metrics?.lastUpdated}</p>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="AlertCircle" size={20} color="var(--color-warning)" />
              <span className="text-2xl font-bold text-warning">{metrics?.issues}</span>
            </div>
          </div>
        </div>

        <button className="w-full inline-flex items-center justify-center gap-2 px-4 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors text-sm font-medium">
          <Icon name="RefreshCw" size={16} />
          Run Validation Check
        </button>
      </div>
    </div>
  );
};

export default ValidationChecks;